import { useTranslation } from 'react-i18next';
import { AutoManagedCommissionStatus, useAutoManagedCommissionFixedDatesQuery } from '@anytag/graphql';
import { Form, Notice } from '@anytag/shared-atoms';
import { useTranslateOptions } from '@anytag/shared-hooks';
import { TextSearchField, SelectorField } from '@anytag/shared-molecules';
import { Option } from '@anytag/shared-types';
import { AutoManagedCommissionsFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
  autoManagedCampaignId: number;
}

export const Template = ({ onSubmit, autoManagedCampaignId }: TemplateProps) => {
  const { t } = useTranslation();
  const { data } = useAutoManagedCommissionFixedDatesQuery({ variables: { id: autoManagedCampaignId } });

  const monthOptions: Option[] =
    data?.autoManagedCommissionFixedDates?.map((date, i) => ({
      value: `${date}_${i}`,
      label: typeof date === 'string' ? date : '-'
    })) || [];
  const statusOptions = useTranslateOptions([
    { label: t<string>('Approved'), value: AutoManagedCommissionStatus.APPROVED },
    { label: t<string>('Not Approved'), value: AutoManagedCommissionStatus.UNAPPROVED }
  ]);

  return (
    <>
      <Notice
        type="info"
        className="mb-2"
        title={t('Commission Information')}
        description={t('InfluencerCommissionFeeNotice')}
      />

      <Form.Fields>
        <TextSearchField<AutoManagedCommissionsFilterFormKeys>
          name="keyword"
          onSubmit={onSubmit}
          placeholder={t<string>('Search.InfluencerFilter')}
        />

        <SelectorField<AutoManagedCommissionsFilterFormKeys>
          name="month"
          onSubmit={onSubmit}
          options={monthOptions}
          className="max-w-49.5"
          placeholder={t<string>('Selector.Month')}
        />

        <SelectorField<AutoManagedCommissionsFilterFormKeys>
          name="status"
          onSubmit={onSubmit}
          options={statusOptions}
          className="max-w-50"
          placeholder={t<string>('Selector.Status')}
        />
      </Form.Fields>
    </>
  );
};
